<!-- 资料详情-查看pdf -->
<template>
  <div id="container">
    <div v-show="loadedRatio===1">
      <!-- 上一页下一页 -->
      <div class="toolbar df jc_sa">
        <!-- 输入页码 -->
        <div class="pageNum">
          <input
            v-model.number="currentPage"
            type="number"
            class="inputNumber"
            @input="inputEvent()"
          > / {{pageCount}}
        </div>
        <!-- 在按钮不符合条件时禁用 -->
        <div class="df ai_c">
          <div
            @click="changePdfPage('pre')"
            class="turn-btn"
            :style="currentPage===1?'cursor: not-allowed;':''"
          >
            上一页
          </div>
          <div class="splitToolbarButtonSeparator"></div>
          <div
            @click="changePdfPage('next')"
            class="turn-btn"
            :style="currentPage===pageCount?'cursor: not-allowed;':''"
          >
            下一页
          </div>
        </div>

        <div class="df ai_c">
          <div
            @click="changePdfPage('first')"
            class="turn"
          >
            首页
          </div>
          <div class="splitToolbarButtonSeparator"></div>
          <div
            @click="changePdfPage('last')"
            class="turn"
          >
            尾页
          </div>
        </div>

      </div>

      <div class="pdfArea">
        <pdf
          :src="fileUrl"
          ref="pdf"
          v-show="loadedRatio===1"
          :page="currentPage"
          @num-pages="pageCount=$event"
          @progress="loadedRatio = $event"
          @page-loaded="currentPage=$event"
          @loaded="loadPdfHandler"
          @link-clicked="currentPage = $event"
          style="display: inline-block;width:100%;height:100vh"
          id="pdfID"
        ></pdf>
      </div>
    </div>
    <!-- 加载未完成时，展示进度条组件并计算进度 -->
    <!-- v-show="loadedRatio!==1" -->
    <div
      class="progress"
      v-show="loadedRatio!==1"
    >
      <van-progress
        color="#569CE4"
        :percentage="Math.floor(loadedRatio * 100)"
      />
      <br>
      <!-- 加载提示语 -->
      <span>{{remindShow}}</span>
    </div>

    <div
      class="downWrapper"
      v-show="iphoneNum"
    >
      <van-button
        type="default"
        class="see"
        :to="'InfoDetails?pageId='+pageId"
      >查看更多</van-button>
      <van-button
        type="primary"
        @click="download"
      >下载 </van-button>
    </div>

    <!-- 资料下载弹框 -->
    <DataPopup :dataPopup="dataPopup" />
  </div>
</template>

<script>
import pdf from "vue-pdf";
import DataPopup from "@/components/DataPopup.vue";

export default {
  components: {
    pdf,
    DataPopup,
  },
  data() {
    return {
      dataPopup: false,
      // ----- loading -----
      remindText: {
        loading: "加载文件中，文件较大请耐心等待...",
        refresh: "若卡住不动，可刷新页面重新加载...",
      },
      remindShow: "加载文件中，文件较大请耐心等待...",
      intervalID: "",
      // ----- vuepdf -----
      // src静态路径: /static/xxx.pdf
      // src服务器路径: 'http://.../xxx.pdf'
      src: "/static/test1.pdf",
      // 当前页数
      currentPage: 0,
      // 总页数
      pageCount: 0,
      // 加载进度
      loadedRatio: 0,
      height: "",
      fileUrl: this.$route.query.fileUrl,
      pageId: this.$route.query.pageId,
      iphoneNum: "",
      fileId: this.$route.query.fileId,
    };
  },
  watch: {
    currentPage(newVal, oldVal) {
      let iphoneNum = localStorage.getItem("iphoneNum");
      // 如果没有填过就弹框
      if (!iphoneNum) {
        if (newVal >= 3) {
          this.dataPopup = true;
        }
      }
    },
  },
  created() {
    this.prohibit();

    let iphoneNum = localStorage.getItem("iphoneNum");
    this.iphoneNum = iphoneNum;
  },
  destroyed() {
    // 在页面销毁时记得清空 setInterval
    clearInterval(this.intervalID);
  },
  mounted() {
    // 更改 loading 文字
    this.intervalID = setInterval(() => {
      this.remindShow === this.remindText.refresh
        ? (this.remindShow = this.remindText.loading)
        : (this.remindShow = this.remindText.refresh);
    }, 4000);
    // 监听滚动条事件
    this.listenerFunction();
  },

  methods: {
    download() {
      if (this.$route.query.fileUrl) {
        window.location.href = this.downloadUrl + this.fileId;
        // this.downloadFile(
        //   this.$route.query.fileUrl,
        //   this.$route.query.fileName
        // );
      }
    },
    // 监听滚动条事件
    listenerFunction(e) {
      document.getElementById("container").addEventListener("scroll", true);
    },
    // 页面回到顶部
    toTop() {
      document.getElementById("container").scrollTop = 0;
    },
    // 输入页码时校验
    inputEvent() {
      if (this.currentPage > this.pageCount) {
        // 1. 大于max
        this.currentPage = this.pageCount;
      } else if (this.currentPage < 1) {
        // 2. 小于min
        this.currentPage = 1;
      }
    },
    // 切换页数
    changePdfPage(val) {
      if (val === "pre" && this.currentPage > 1) {
        // 切换后页面回到顶部
        this.currentPage--;
        this.toTop();
      } else if (val === "next" && this.currentPage < this.pageCount) {
        this.currentPage++;
        this.toTop();
      } else if (val === "first") {
        this.currentPage = 1;
        this.toTop();
      } else if (val === "last" && this.currentPage < this.pageCount) {
        this.currentPage = this.pageCount;
        this.toTop();
      }
    },

    // pdf加载时
    loadPdfHandler(e) {
      // 加载的时候先加载第一页
      this.currentPage = 1;
    },

    // 禁用鼠标右击、F12 来禁止打印和打开调试工具
    prohibit() {
      // console.log(document)
      document.oncontextmenu = function () {
        return false;
      };
      document.onkeydown = function (e) {
        if (
          e.ctrlKey &&
          (e.keyCode === 65 ||
            e.keyCode === 67 ||
            e.keyCode === 73 ||
            e.keyCode === 74 ||
            e.keyCode === 80 ||
            e.keyCode === 83 ||
            e.keyCode === 85 ||
            e.keyCode === 86 ||
            e.keyCode === 117)
        ) {
          return false;
        }
        if (e.keyCode === 18 || e.keyCode === 123) {
          return false;
        }
      };
    },
  },
};
</script>

<style scoped>
.toolbar {
  height: 32px;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 99;
  background-color: #f9f9fa;
  font-size: 12px;
}

#container {
  overflow: auto;
  min-height: 100vh;
  font-family: PingFang SC;
  width: 100%;
  display: flex;
  /* justify-content: center; */
  position: relative;
  background-color: #ececef;
}

/* 右侧功能按钮区 */
.right-btn {
  position: fixed;
  right: 5%;
  bottom: 15%;
  width: 120px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  z-index: 99;
}

.pdfArea {
  width: 100%;
  margin-top: 48px;
  padding: 0 16px;
  box-sizing: border-box;
}

/* ------------------- 输入页码 ------------------- */
.pageNum {
  font-size: 12px;
}
/*在谷歌下移除input[number]的上下箭头*/
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
/*在firefox下移除input[number]的上下箭头*/
input[type="number"] {
  -moz-appearance: textfield;
}

.inputNumber {
  border: 1px solid #999999;
  font-size: 12px;
  width: 40px;
  /* text-align: center; */
  text-align: right;
  padding: 4px 7px;
  margin: 3px 0 3px 0;
  border-radius: 2px;
}
.inputNumber:focus {
  border: 1px solid #00aeff;
  background-color: rgba(18, 163, 230, 0.096);
  outline: none;
  transition: 0.2s;
}

/* ------------------- 切换页码 ------------------- */
.splitToolbarButtonSeparator {
  padding: 10px 0;
  width: 1px;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 99;
  display: inline-block;
  margin: 4px 0;
}

.turn {
  padding: 0 6px 0;
}

.turn-btn {
  padding: 0 6px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.turn-btn:hover,
.turn:hover {
  transition: 0.3s;
  opacity: 0.5;
  cursor: pointer;
}

/* ------------------- 进度条 ------------------- */
.progress {
  position: absolute;
  text-align: center;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.progress > span {
  color: #222222;
  font-size: 14px;
  font-weight: 600;
}
</style>